var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item,index){return _c('item',{key:item.script_id,attrs:{"js":item,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }